/** Attribute Constructor Factory
    @see https://stackoverflow.com/a/502384/722785
    @param {[string,any][]} params Constructor parameters and default values names ie: [['first','john'],['last','smith']]
*/
export const makeAttrStruct = (params = []) => {
    /** Structure Constructor */
    const constructor = (...args) => {
        const attributes = {};
        for (let i = 0; i < params.length; i++) {
            attributes[params[i][0]] = args[i] !== undefined ? args[i] : params[i][1]; // fallback to default value
        }
        return attributes;
    };
    return constructor;
};
